import { StudentReviewAssignment } from "shared/types/science35Types"
import styles from "./styles.module.scss"
import { isMastered, exceedsMastery } from "shared/helpers/calculateMastery"

interface StudentCoreIdeaCardProps {
    index: number
    assignment: StudentReviewAssignment
    onSelect: (assignmentId: string) => void
    selected: boolean
    isLastCompleted: boolean
}

const StudentCoreIdeaCard = ({ index, assignment, onSelect, selected, isLastCompleted } : StudentCoreIdeaCardProps) => {
    const mastered = isMastered(assignment)
    const exceededMastery = exceedsMastery(assignment)

    const { coreIdeaCard, cardSelectedMastered, cardSelectedNotMastered } = styles

    const className = `${mastered ? (selected ? cardSelectedMastered : "bg-success") : (selected ? cardSelectedNotMastered : "bg-primary")} ${coreIdeaCard}`
    const cardColor = `${mastered ? (selected ? 'rgba(15, 81, 50, 0.92)' : 'rgba(25, 135, 84, 0.8)') : (selected ? 'rgba(5, 53, 124, 0.92)' : 'rgba(64, 74, 189, 0.8)')}`

  return (
    <div key={index}>
        <button
            className={className}
            style={{backgroundImage: `linear-gradient(0deg, ${cardColor}), url(${assignment.assignment.review.image})`}}
            onClick={() => onSelect(assignment.assignment.id)}
        >    
            {assignment.label && <p className="fs-5 fw-bold mb-0" dangerouslySetInnerHTML={{ __html: assignment.label }}></p>}
            <p className={`${assignment.label ? "fs-8" : "fs-5"} fw-bold mb-0`} dangerouslySetInnerHTML={{ __html: assignment.name }}></p>
            {selected && 
                <i className="fas fa-bookmark position-absolute top-0 end-0 fs-3 text-white" style={{ marginRight: '1rem', marginTop: '0' }}></i>
            }
            {isLastCompleted && 
                <span className="bg-white text-dark rounded position-absolute bottom-0 start-0 fs-6 p-1 ms-1 mb-1"><i className="fa-solid fa-clock text-success ms-1"></i> Last Completed</span>}
            {(mastered) ?
                <i className="fas fa-medal fs-1 position-absolute bottom-0 end-0 mb-2 me-2" style={{ ...(exceededMastery ? { color: "gold" } : { color: "silver" }) }}></i>
            :
                <div className="d-flex flex-row position-absolute bottom-0 start-0">
                    <i className={`fas ${assignment.pretestGrade !== null ? "fa-check-circle opacity-75" : "fa-circle opacity-25"} ms-2 mb-2`}></i>
                    <i className={`fas ${assignment.lessonViewed ? "fa-check-circle opacity-75" : "fa-circle opacity-25"} ms-2 mb-2`}></i>
                    <i className={`fas ${assignment.lessonGrade !== null ? "fa-check-circle opacity-75" : "fa-circle opacity-25"} ms-2 mb-2`}></i>
                </div>
            }
        </button>
    </div>
  )
}

export default StudentCoreIdeaCard
